import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../service/modules/modules.component';
import { ServerService } from '../../service/server/server.service';
import { MessageService } from '../../service/message/message.service';

@Component({
  selector: 'app-ckd-material2-detaile',
  templateUrl: './ckd-material2-detaile.component.html',
  styleUrls: ['./ckd-material2-detaile.component.scss']
})
export class CkdMaterial2DetaileComponent implements OnInit, OnDestroy {
  public server: any = this.serverService.get_server();
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public loading = false;
  public subscription: Subscription;
  public type_task: number | undefined;
  public form1_group: FormGroup | any;
  public user_id: number | any;
  public id: number | undefined;
  public code: number | undefined;
  public title: string | undefined;
  public search_array: any = [];
  public not_update_ckd: boolean | undefined;
  public not_update_ckd2: boolean | undefined;
  public readonly: boolean = true;
  public seleton_id: number;
  public tip: number;


  constructor(
    public serverService: ServerService
    , public router: Router
    , public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any
    , public dialog: MatDialog
    , public messageService: MessageService
    , public matDialogRef: MatDialogRef<CkdMaterial2DetaileComponent>) {

    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.seleton_id = dialog_data.seleton_id;
      this.tip = dialog_data.tip;
      this.type_task = dialog_data.type_task;
      this.type_task = dialog_data.type_task;
      this.id = dialog_data.id;
      this.title = dialog_data.title;
      this.code = dialog_data.code;
      this.readonly = dialog_data.readonly;
      this.create_form1();
      if (this.type_task == 1) {
      }
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        this.check_access(3, 1);
      }

    }
  }//end consructor

  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }

  create_form1() {
    this.form1_group = new FormGroup({
      'number': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'price': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'discount': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'pert': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'nasb': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'sod': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'haml': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'haml2': new FormControl(null, [Validators.pattern('[0-9]{1,}')])
    });
    if (this.type_task == 2 || this.type_task == 1) {
      this.form1_group.controls['number'].setValidators([Validators.required]);
      this.form1_group.controls['price'].setValidators([Validators.required]);
      this.form1_group.controls['discount'].setValidators([Validators.required]);
      this.form1_group.controls['pert'].setValidators([Validators.required]);
      this.form1_group.controls['nasb'].setValidators([Validators.required]);
      this.form1_group.controls['sod'].setValidators([Validators.required]);
      this.form1_group.controls['haml'].setValidators([Validators.required]);
      this.form1_group.controls['haml2'].setValidators([Validators.required]);
    }

  }

  check_access(type_task: any, excel: number): any {
    if (this.serverService.check_internet1() == false) {
      this.message(true, this.messageService.internet(this.lang), 1, this.messageService.close(this.lang));
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: 222 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(this.lang), 1, this.messageService.close(this.lang));
          }
          else {
            this.loading = false;
            if (type_task == 1) { this.insert(); }
            if (type_task == 2) { this.update(); }
            if (type_task == 3) {
              this.form1_group.patchValue({
                title: this.dialog_data.search_array.title,
                status_id: this.dialog_data.search_array.status_id,
                status_title: this.dialog_data.search_array.status_title,
              })
            }
            if (type_task == 4) { this.get_data(); }
          }
        }//end if
        else {
          this.message(true, this.messageService.access(this.lang), 1, this.messageService.close(this.lang));
        }
      }
    )
  }

  search(excel: number) {
    this.matDialogRef.close({
      title: this.form1_group.value.title,
      status_id: this.form1_group.value.status_id,
      status_title: this.form1_group.value.status_title,
      export_excel: excel
    })
  }

  get_data() {
    if (this.serverService.check_internet1() == false) {
      this.message(true, this.messageService.internet(this.lang), 1, this.messageService.close(this.lang));
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10567, id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'number': res['result'][0].wharehouse_order_number,
            'price': res['result'][0].wharehouse_order_cost,
            'discount': res['result'][0].wharehouse_order_discount,
            'pert': res['result'][0].wharehouse_order_pert,
            'nasb': res['result'][0].wharehouse_order_nasb,
            'sod': res['result'][0].wharehouse_order_sod,
            'haml': res['result'][0].wharehouse_order_haml,
            'haml2': res['result'][0].wharehouse_order_haml2,
          }
          )
          //******************** */
          if ((this.seleton_id >= 0 && res['result'][0].wharehouse_order_skeleton > 0) || this.tip > 0) {
            this.not_update_ckd = true;
          }
          else {
            this.not_update_ckd = false;
          }
          this.form1_group.controls['number'].disable = true;
          //******************** */
          if ((this.seleton_id >= 0 && res['result'][0].wharehouse_order_skeleton > 0)) {
            this.not_update_ckd2 = true;
          }
          else {
            this.not_update_ckd2 = false;
          }
          //******************** */

          this.message(false, "", 1, this.messageService.close(this.lang));
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(this.lang), 1, this.messageService.close(this.lang));
        }
      }
    )
  }


  insert() {
    if (this.readonly == true) {
      return false;
    }
    if (this.serverService.check_internet1() == false) {
      this.message(true, this.messageService.internet(this.lang), 1, this.messageService.close(this.lang));
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 1671, "user_id": this.user_id, 'status_id': this.form1_group.value.status_id
      , 'title': this.form1_group.value.title
      , 'sort': this.form1_group.value.sort
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0] }
          )
          this.message(true, this.messageService.save(this.lang), 1, this.messageService.close(this.lang));
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(this.lang), 1, this.messageService.close(this.lang));
        }
        else {
          this.message(true, this.messageService.erorr_in_load(this.lang), 1, this.messageService.close(this.lang));
        }
      }
    );
  }//end insert

  update() {
    if (this.readonly == true) {
      return false;
    }
    if (this.serverService.check_internet1() == false) {
      this.message(true, this.messageService.internet(this.lang), 1, this.messageService.close(this.lang));
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 10568, "user_id": this.user_id
      , 'number': this.form1_group.value.number
      , 'price': this.form1_group.value.price
      , 'discount': this.form1_group.value.discount
      , 'pert': this.form1_group.value.pert
      , 'nasb': this.form1_group.value.nasb
      , 'sod': this.form1_group.value.sod
      , 'haml': this.form1_group.value.haml
      , 'haml2': this.form1_group.value.haml2
      , 'id': this.id, not_update_ckd: this.not_update_ckd
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0] }
          )
          this.message(true, this.messageService.save(this.lang), 1, this.messageService.close(this.lang));

        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(this.lang), 1, this.messageService.close(this.lang));
        }
        else {
          this.message(true, this.messageService.erorr_in_save(this.lang), 1, this.messageService.close(this.lang));

        }
      }
    );
  }//end update

  get_status() {
    if (this.serverService.check_internet1() == false) {
      this.message(true, this.messageService.internet(this.lang), 1, this.messageService.close(this.lang));
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1064 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            status_id: res['result'][0].status_id,
            status_title: res['result'][0].status_title,
          })
          this.message(false, "", 1, this.messageService.close(this.lang));
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(this.lang), 1, this.messageService.close(this.lang));
        }
      }
    )
  }


  load_services(id: number) {
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 26) {
            this.form1_group.patchValue({
              'status_id': res.id,
              'status_title': res.title
            })
          }
        }
      }
    )

  }


  reset_input(id: number) {
    if (id == 26) {
      this.form1_group.patchValue({
        'status_title': null,
        'status_id': null
      })
    }
  }


  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }

  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}

